import { render, staticRenderFns } from "./CookieModal.vue?vue&type=template&id=fed37ed8&scoped=true"
import script from "./CookieModal.vue?vue&type=script&lang=js"
export * from "./CookieModal.vue?vue&type=script&lang=js"
import style0 from "./CookieModal.vue?vue&type=style&index=0&id=fed37ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed37ed8",
  null
  
)

export default component.exports